import { Spin } from "antd";
import { useFlow, FLOWS } from "hook/bailiff/document/flow/useFlow";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffLoading = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const isFlow = flow === FLOWS.LOADING;
  console.log({ flow });
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <div className="flex min-h-[100vh] flex-row items-center justify-center">
      <Spin />
    </div>
  );
};
export default BailiffLoading;
